import { Status } from 'civic-champs-shared/api/hooks/fetchRefactoredSchema'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import { SavedFilter } from 'core/table/interfaces/TablePersistence'

export const useSetTableFilters = (): [
  (tableName: string, filters: SavedFilter[]) => Promise<SavedFilter[]>,
  Status<SavedFilter[]>,
] => {
  const [request, status] = useFetchRefactored<SavedFilter[]>({
    emptyValue: undefined,
  })

  const setTableFilters = useCallback(
    (tableName, filters) =>
      request({
        method: 'put',
        url: `/user/tables/${tableName}/filters`,
        config: {
          body: filters,
        },
      }),
    [request],
  )

  return [setTableFilters, status]
}

export default useSetTableFilters
